import axios from "axios";
import { useEffect, useState } from "react";
import SavePaymentMethodForm from "./PaymentMethod/save_payment_method_form";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import BillingHistory from "./History/history";
import BillingOverview from "./Overview/overview";
import BillingPaymentMethod from "./PaymentMethod/payment_method";
import { useNavigate } from 'react-router-dom';
import './billing.css'
import BillingCancel from "./CancelSubscription/CancelSubscription";
import { getAuth } from "firebase/auth";
import { get } from "../../Services/api";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function Billing({ user_data, page, userInfo }) {
    const auth = getAuth();

    const [billingData, setBillingData] = useState();
    const [subscriptionDetail, setSubscriptionDetail] = useState();
    const navigate = useNavigate();

    function goToPage(path) {
        navigate(path);
    }

    useEffect(() => {
        getBillingDetail()
    }, []);

    async function getBillingDetail() {
        const idToken = await auth.currentUser?.getIdToken();
        const res = await get("/api/billing/stripe/get-billing-detail?user_id=" + user_data.uid, {
            headers: {
                Authorization: idToken ? `Bearer ${idToken}` : undefined,
            }
        })

        if (res && res !== 500) {
            setBillingData(res)

            // get stripe subscription
            const res_sub = await get("/api/billing/stripe/get-subscription?id=" + res.subscription_id, {
                headers: {
                    Authorization: idToken ? `Bearer ${idToken}` : undefined,
                }
            })

            if (res_sub && res_sub !== 500)
                setSubscriptionDetail(res_sub)

            if (page == 'cancel' && res_sub.status == 'canceled')
                window.location = '/'
        } else if (page == 'cancel')
            window.location = '/'
        else
            setBillingData(null)
    }

    return (
        <div>
            <p className="font_weight_600 font_size_28">Billing</p>
            <div className="billing_option_setting">
                <div className="flex gap_20">
                    <p className={(page == 'overview' ? 'billing_option_selected font_weight_600' : 'billing_option_indiv_setting gray_scale_1') + " cursor_pointer"}
                        onClick={() => goToPage('/billing/overview')}>Overview</p>
                    <p className={(page == 'payment_method' ? 'billing_option_selected font_weight_600' : 'billing_option_indiv_setting gray_scale_1') + " cursor_pointer"}
                        onClick={() => goToPage('/billing/payment-methods')}>Payment Methods</p>
                    <p className={(page == 'history' ? 'billing_option_selected font_weight_600' : 'billing_option_indiv_setting gray_scale_1') + " cursor_pointer"}
                        onClick={() => goToPage('/billing/history')}>Billing History</p>

                    {page == 'cancel' ? <p className="billing_option_selected font_weight_600 cursor_default">Cancel Subscription</p> : null}
                </div>

                <div className="billing_option_setting_divider"></div>
            </div>

            {page == 'overview' ? <BillingOverview userInfo={userInfo} billingData={billingData} subscriptionDetail={subscriptionDetail} /> : null}
            {page == 'payment_method' ? <BillingPaymentMethod user_data={user_data} billingData={billingData} /> : null}
            {page == 'history' ? <BillingHistory billingData={billingData} /> : null}
            {billingData && billingData.payment_provider_fk == 2 && page == 'cancel' ? <BillingCancel userInfo={userInfo} billingData={billingData} /> : null}
        </div>
    );
}


export default Billing;